import type { AppConfiguration, GenesysSettings } from '../types';

export const getGenesysSettings = ({
  appUrl,
  orgId,
  deploymentId,
  queue,
  customerId,
  title,
  dataURL,
  consultantNumber,
  phoneNumber,
  language,
  tenant,
  maxMessageLength,
}: AppConfiguration): GenesysSettings => {
  const i18nUrl = new URL(appUrl);

  return {
    widgets: {
      main: {
        theme: 'light',
        downloadGoogleFont: false,
        lang: language,
        i18n: `${i18nUrl.origin}/static${i18nUrl.pathname}assets/widgets-${language}.i18n.json`,
        webchat: {
          maxMessageLength,
        },
      },
      webchat: {
        maxMessageLength,
        transport: {
          type: 'purecloud-v2-sockets',
          dataURL,
          deploymentKey: deploymentId,
          orgGuid: orgId,
          interactionData: {
            routing: {
              targetType: 'QUEUE',
              targetAddress: queue,
              priority: 2,
            },
          },
        },
        markdown: true,
        userData: {
          customerId: customerId === -1 ? undefined : customerId,
          phoneNumber,
          customField1Label: 'Customer Title',
          customField1: customerId === -1 ? 'Anonymous' : title,
          customField2Label: consultantNumber === 0 ? undefined : 'Consultant Number',
          customField2: consultantNumber === 0 ? undefined : consultantNumber,
          customField3Label: language ? 'Language Code' : undefined,
          customField3: language?.toUpperCase(),
          customField4Label: tenant ? 'Market Code' : undefined,
          customField4: tenant?.toUpperCase(),
        },
        confirmFormCloseEnabled: false,
      },
    },
  };
};
